import { render, staticRenderFns } from "./GroupsController.vue?vue&type=template&id=40e35f5b&scoped=true"
import script from "./GroupsController.vue?vue&type=script&lang=ts"
export * from "./GroupsController.vue?vue&type=script&lang=ts"
import style0 from "./GroupsController.vue?vue&type=style&index=0&id=40e35f5b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40e35f5b",
  null
  
)

export default component.exports